jQuery(document).ready(function($) {

    $( ".bloc_droitegauche .paragraphe" ).each(function( index ) {

        var parent = $(this)
        var txt = $(this).find(".contenu")
        var img = $(this).find(".visuel")

        gsap.set(img, { clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)' })

        // décalage réduit sous 1024px : sur mobile l'encart passe sous le visuel
        gsap.from( txt, {
            y : function () {
                return window.matchMedia("(max-width: 1023.98px)").matches ? 60 : 200
            },
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
                trigger: parent,
                markers: false,
                start: "top 80%",
                end: "bottom 100%",
                scrub: 1,
                invalidateOnRefresh: true,
            }

        })

        gsap.from( img, {
            clipPath: 'polygon(50% 50%, 50% 50%, 50% 50%, 50% 50%)',
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
                trigger: parent,
                markers: false,
                start: "top 80%",
                end: "bottom 100%",
                scrub: 1,
            }

        })

    })

});